export interface CreateBibliographySearchAuthorityListRequest {
  formatType: CreateBibliographySearchAuthorityListFormatType
  authorities: {
    authorityNo: string
    display: string
    reference: string
    specialty: string
    yearOfBirth: string
    work: string
    bibliographyCount: string
  }[]
}

export const CreateBibliographySearchAuthorityListFormatType = {
  All: '1',
  Simple: '2'
}
export type CreateBibliographySearchAuthorityListFormatType = typeof CreateBibliographySearchAuthorityListFormatType[keyof typeof CreateBibliographySearchAuthorityListFormatType]

export function CreateBibliographySearchAuthorityListRequestToJSON(
  value: CreateBibliographySearchAuthorityListRequest
): any {
  return {
    format_type: value.formatType !== '' ? value.formatType : undefined,
    authorities:
      value.authorities.length > 0
        ? value.authorities.map(authority => {
            return {
              authority_no:
                authority.authorityNo !== ''
                  ? authority.authorityNo
                  : undefined,
              display: authority.display !== '' ? authority.display : undefined,
              reference:
                authority.reference !== '' ? authority.reference : undefined,
              specialty:
                authority.specialty !== '' ? authority.specialty : undefined,
              year_of_birth:
                authority.yearOfBirth !== ''
                  ? authority.yearOfBirth
                  : undefined,
              work: authority.work !== '' ? authority.work : undefined,
              bibliography_count:
                authority.bibliographyCount !== ''
                  ? authority.bibliographyCount
                  : undefined
            }
          })
        : undefined
  }
}
